/* eslint-disable indent */
import { Component, OnInit } from '@angular/core';
import { CarregandoService } from '../services/carregando.service';
import { FuncionarioService } from '../services/funcionario.service';
import { NotificacaoService } from '../services/notificacao.service';

@Component({
  selector: 'app-transferencia-itens-vendedor',
  templateUrl: './transferencia-itens-vendedor.component.html',
  styleUrls: ['./transferencia-itens-vendedor.component.scss']
})
export class TransferenciaItensVendedorComponent implements OnInit {

  status = [{ id: null, nome: 'Todos' }, { id: true, nome: 'Ativo' }, { id: false, nome: 'Bloqueado' }];
  funcionarios = [];
  funcionariosDe = [];
  funcionariosPara = [];
  statusDe = null;
  statusPara = null;
  funcionarioDe = null;
  funcionarioPara = null;
  idCupom = null;
  idIntegrador = null;
  idContato = null;
  nomeIntegrador = null;

  somentePedido = false;
  somenteIntegrador = false;
  somenteOrcamento = false;

  acoes = {
    TransferirClientesIntegradores: false,
    TransferirOrcamentos: false,
    TransferirPedidos: {
      Sim: false,
      Pendentes: false,
      Confirmados: false,
      Expirados: false,
    }
  };

  constructor(private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private funcionarioService: FuncionarioService,) { }

  ngOnInit() {
    this.buscarFuncionarios('de');
    this.buscarFuncionarios('para');
  }

  buscarFuncionarios(tipo: string) {
    this.carregandoService.mostra('buscaFuncionarios');

    let todos = false;
    let somenteAtivos = false;
    let somenteBloqueados = false;

    switch (tipo) {
      case 'de':
        todos = this.statusDe === null;
        somenteAtivos = this.statusDe === true;
        somenteBloqueados = this.statusDe === false;
        break;
      case 'para':
        todos = this.statusPara === null;
        somenteAtivos = this.statusPara === true;
        somenteBloqueados = this.statusPara === false;
        break;
    }

    this.funcionarioService.consultarFuncionarios(todos, somenteAtivos, somenteBloqueados).subscribe(dados => {
      switch (tipo) {
        case 'de':
          this.funcionariosDe = dados;
          break;
        case 'para':
          this.funcionariosPara = dados;
          break;
      }

      this.carregandoService.esconde('buscaFuncionarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaFuncionarios');
      this.notificacaoService.erro(erro);
    });
  }

  onChangeStatusDe() {
    this.buscarFuncionarios('de');
  }

  onChangeStatusPara() {
    this.buscarFuncionarios('para');
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    const vm = {
      funcionarioDe: this.funcionarioDe,
      funcionarioPara: this.funcionarioPara,
      statusDe: this.statusDe,
      statusPara: this.statusPara,
      idCupom: this.idCupom,
      idIntegrador: this.idIntegrador,
      idContato: this.idContato,
      acoes: this.acoes
    };

    this.funcionarioService.transferirItemsVendedor(vm).subscribe(result => {
      this.notificacaoService.sucesso('Transferência realizada com sucesso!');
      this.carregandoService.esconde('salvar');
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });
  }

}
